var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.007 24c1.049 0 1.865-.279 2.45-.837.584-.557.876-1.339.876-2.344V11.18c0-1.012-.276-1.795-.829-2.35C19.952 8.278 19.151 8 18.103 8H7.337c-1.013 0-1.823.277-2.428.832-.606.554-.909 1.34-.909 2.36v9.658c0 1.012.292 1.79.877 2.334.584.544 1.404.816 2.46.816h10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.834 22.667c.342 0 .622-.133.84-.397.217-.265.326-.609.326-1.032V10.751c0-.423-.109-.765-.326-1.026a1.043 1.043 0 0 0-.84-.392c-.174 0-.35.05-.531.148-.18.1-.357.23-.531.392l-3.506 2.214a2 2 0 0 0-.933 1.69v4.06a2 2 0 0 0 .811 1.607l3.628 2.683c.174.162.35.293.531.392.18.098.357.148.531.148z",
    opacity: 0.163
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulVideo);
export default __webpack_public_path__ + "static/media/icons-colorful-video.c9c22111.svg";
export { ForwardRef as ReactComponent };